import React from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

const selectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
    color: '#000',
    ':hover': {
      backgroundColor: '#F5F5F5',
      color: '#000 ',
    },
  }),
};

const CommunityDetails = ({ formData, setFormData, countriesList, cityList, onCountryChange, readOnly = false, tableLoading = false, isNew = false }) => {
  const { t } = useTranslation();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (name, selected) => {
    if (name === 'country') {
      onCountryChange(selected);
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: selected }));
  };

  return (
    <div className="cost-center-section my-3">
      <div className="border-box2 p-3 position-relative" style={{ borderRadius: '8px' }}>
        {tableLoading && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(255,255,255,0.6)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10,
            }}
          >
            <div className="spinner-border text-primary" role="status" />
          </div>
        )}
        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '20px' }}>
          <div className="d-flex flex-column">
            <label className="form-label">{t('communityMaster.fields.communityNo')}</label>
            <input
              type="text"
              className="p-2 form-control"
              name="communityNo"
              value={isNew ? '' : formData.communityNo}
              onChange={handleInputChange}
              disabled
              placeholder={isNew ? t('communityMaster.fields.communityNoAutoGenerated') : ''}
            />
          </div>
          <div className="d-flex flex-column">
            <label className="form-label">{t('communityMaster.fields.descriptionEn')}</label>
            <input
              type="text"
              className="p-2 form-control"
              name="descriptionEn"
              value={formData.descriptionEn}
              onChange={handleInputChange}
              disabled={readOnly}
            />
          </div>
          <div className="d-flex flex-column">
            <label className="form-label">{t('communityMaster.fields.descriptionAr')}</label>
            <input
              type="text"
              className="p-2 form-control"
              name="descriptionAr"
              value={formData.descriptionAr}
              onChange={handleInputChange}
              disabled={readOnly}
            />
          </div>
          <div className="d-flex flex-column">
            <label className="form-label">{t('communityMaster.fields.country')}</label>
            <Select
              className="p-0 w-100"
              menuPortalTarget={document.body}
              styles={selectStyles}
              options={countriesList?.map((item) => ({ value: item, label: item?.text }))}
              value={formData.country}
              onChange={(selected) => handleSelectChange('country', selected)}
              isDisabled={readOnly}
              isClearable
            />
          </div>
          <div className="d-flex flex-column">
            <label className="form-label">{t('communityMaster.fields.city')}</label>
            <Select
              className="p-0 w-100"
              menuPortalTarget={document.body}
              styles={selectStyles}
              options={cityList?.map((item) => ({ value: item, label: item?.text }))}
              value={formData.city}
              onChange={(selected) => handleSelectChange('city', selected)}
              isDisabled={readOnly || !formData.country}
              isClearable
            />
          </div>
          <div className="d-flex flex-column" style={{ gridColumn: '1 / -1' }}>
            <label className="form-label">{t('communityMaster.fields.marketingDescription')}</label>
            <textarea
              className="p-2 form-control"
              name="marketingDescription"
              rows={4}
              value={formData.marketingDescription}
              onChange={handleInputChange}
              disabled={readOnly}
              style={{ resize: 'vertical', minHeight: '120px' }}
            />
          </div>
          <div className="d-flex flex-column" style={{ gridColumn: '1 / -1' }}>
            <label className="form-label">{t('communityMaster.fields.remarks')}</label>
            <textarea
              className="p-2 form-control"
              name="remarks"
              rows={4}
              value={formData.remarks}
              onChange={handleInputChange}
              disabled={readOnly}
              style={{ resize: 'vertical', minHeight: '120px' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommunityDetails;
